export default __webpack_public_path__ + "static/media/SI.e7d45ba2.svg";